import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';
import { sendTaggingInfo } from '@/utils/common';
import ICON_ID from '@gcloud-npm/utils.enums.icon-id';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';
import IconGlyph from '@/bit/components/components.icon-glyph';
import customStyles from './customStyles';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <IconGlyph
        id={
          props.selectProps.menuIsOpen ? ICON_ID.CheuronUp : ICON_ID.CheuronDown
        }
        layoutSize={{ width: 14 }}
        color={COLOR_DICTIONARY.BLUEA}
      />
    </components.DropdownIndicator>
  );
};
function CustomSelect({
  className,
  instanceId,
  name,
  error,
  options,
  onChange,
  placeholder,
  defaultValue,
  isSearchable,
  value,
  showDropDown = false,
  openMenuOnFocus = true,
}) {
  const [optionSelected, setOptionSelected] = useState(defaultValue);

  useEffect(() => {
    setOptionSelected(value);
  }, [value]);

  const taggingInfo = {
    componentVariation: 'all',
    componentProduct: '',
    componentName: 'select',
    componentContent: placeholder,
  };
  const handleOnFocus = () => {
    sendTaggingInfo(taggingInfo, 'focus');
  };
  const handleSelectChange = (option) => {
    sendTaggingInfo(taggingInfo, 'select-option');
    onChange(option);
    setOptionSelected(option);
  };
  return (
    <div className={`select ${className}`}>
      <Select
        aria-label={placeholder}
        instanceId={instanceId}
        name={name}
        id={instanceId}
        value={optionSelected || { label: 'Nº Movistar', value: '' }}
        defaultValue={defaultValue || { label: 'Nº Movistar', value: '' }}
        isSearchable={isSearchable}
        options={options}
        placeholder={placeholder}
        isClearable={false}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: showDropDown && DropdownIndicator,
        }}
        autoFocus={openMenuOnFocus}
        openMenuOnFocus={openMenuOnFocus}
        onFocus={handleOnFocus}
        styles={customStyles}
        onChange={handleSelectChange}
        noOptionsMessage={() => 'No hay resultados'}
        inputProps={{
          autoComplete: 'off',
          autoCorrect: 'off',
          spellCheck: 'off',
        }}
      />
      {error && (
        <Text
          className="select__error"
          text={error}
          color={TEXT_COLOR.RED}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
        />
      )}
      <style jsx>
        {`
          @import '../../../styles/colors.scss';
          .select {
            position: relative;
          }
          :global(.selectMigra) {
            height: 20px;
          }
          :global(.select__error) {
            color: $color-gp--red;
            font-family: Regular;
            font-size: 12px;
            padding: 4px 0 0 12px;
          }
        `}
      </style>
    </div>
  );
}
CustomSelect.propTypes = {
  instanceId: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.object,
  isSearchable: PropTypes.bool,
};

CustomSelect.defaultProps = {
  className: '',
  error: '',
  onChange: () => {},
  placeholder: '',
  defaultValue: null,
  isSearchable: false,
};
export default CustomSelect;
